import getImageById from 'editor/src/store/gallery/selector/getImageById';
import { addUploadedImagesAction } from 'editor/src/store/gallery/slice';
import type { Thunk } from 'editor/src/store/hooks';

import { getLibraryImageById } from '../selector';

/**
 * Placing, exporting and previewing an image all look it up in the gallery, so a library image
 * joins the gallery before it is used. Done on use rather than on load, so autofill and the
 * gallery counts only ever see images the customer picked.
 */
const addLibraryImageToGalleryOperation =
  (imageId: string): Thunk =>
  (dispatch, getState) => {
    const state = getState();
    if (getImageById(state, imageId)) {
      return;
    }
    const libraryImage = getLibraryImageById(state, imageId);
    if (!libraryImage) {
      return;
    }
    const { uuid, ...image } = libraryImage;
    dispatch(addUploadedImagesAction([image]));
  };

export default addLibraryImageToGalleryOperation;
